import { render, staticRenderFns } from "./evaluationManage.vue?vue&type=template&id=5c21fc18&scoped=true&"
import script from "./evaluationManage.vue?vue&type=script&lang=ts&"
export * from "./evaluationManage.vue?vue&type=script&lang=ts&"
import style0 from "./evaluationManage.vue?vue&type=style&index=0&id=5c21fc18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c21fc18",
  null
  
)

export default component.exports